require('angular');
require('./angular-loggly-logger');
module.exports = 'logglyLogger';



//////////////////
// WEBPACK FOOTER
// ./~/angular-loggly-logger/index.js
// module id = 119
// module chunks = 14